export default __webpack_public_path__ + "static/media/FINANCIERA.f5cf9159.png";